'use es6';

export default function (options) {
  const {
    errorRenderer,
    noDataRenderer,
    track,
    setIsRendered,
    inBrowser = true,
    isPreview
  } = options;
  return {
    errorRenderer,
    noDataRenderer,
    track,
    setIsRendered,
    disableIframes: isPreview || !inBrowser,
    disableSVGs: isPreview || !inBrowser
  };
}